import { render, staticRenderFns } from "./myOrder.vue?vue&type=template&id=2c8c8c6e"
import script from "./myOrder.vue?vue&type=script&lang=js"
export * from "./myOrder.vue?vue&type=script&lang=js"
import style0 from "./myOrder.vue?vue&type=style&index=0&id=2c8c8c6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports